import React, { createContext, useContext, useState } from 'react';

const ClinicContext = createContext();

export function ClinicProvider({ children }) {
  const [clinicId, setClinicId] = useState(null);
  return (
    <ClinicContext.Provider value={{ clinicId, setClinicId }}>
      {children}
    </ClinicContext.Provider>
  );
}

export function useClinic() {
    const context = useContext(ClinicContext);
    if (!context) {
      throw new Error("useClinic must be used within a ClinicProvider");
    }
    return context;
  }
  

